import React from 'react';
import { Route, IndexRoute } from 'react-router';
import TransferRequests from './transferRequests';

export default (
  <Route path="transferencias">
    <IndexRoute component={(props) => <TransferRequests {...props} />} />
  </Route>
);
